/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Theme } from "@mui/material";

export const styledToastContainerStyle = {
  container: (theme: Theme) => ({
    "--toastify-icon-color-success": theme.palette.success.main,
    "--toastify-color-progress-success": theme.palette.success.main,
    "--toastify-icon-color-warning": theme.palette.warning.main,
    "--toastify-color-progress-warning": theme.palette.warning.main,
    "--toastify-icon-color-error": theme.palette.error.main,
    "--toastify-color-progress-error": theme.palette.error.main,
    "--toastify-toast-offset": 0,
    "--toastify-toast-top": 0,
    "--toastify-container-width": "100%",
    "--toastify-toast-width": "100%",
    "--toastify-toast-padding": 0,
    "--toastify-toast-shadow": theme.shadows[4],
    "--toastify-toast-bd-radius": 0,
    [theme.breakpoints.up("sm")]: {
      "--toastify-toast-top": "1rem",
      "--toastify-toast-width": "450px",
      "--toastify-container-width": "fit-content",
      "--toastify-toast-bd-radius": `${theme.shape.borderRadius}px`,
    },
    ".Toastify__toast": {
      textAlign: "center",
      justifyContent: "center",
      overflow: "hidden",
      marginBottom: "0",
      [theme.breakpoints.up("sm")]: {
        marginBottom: "1rem",
      },
    },
    ".Toastify__close-button": {
      display: "flex",
      alignItems: "center",
      top: 0,
      right: "1rem",
      fontSize: "1rem",
      height: "var(--toastify-toast-min-height)",
    },
  }),
};
